import moment from 'moment';
import React from 'react';

import {CalendarEntryTask} from 'calendar/CalendarConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import {Party} from 'parties/PartyConstants';
import {AvatarSize} from 'ui-library/avatar/AvatarConstants';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import PartyAvatarList from 'ui-library/PartyAvatarList';

import EntryTask from './EntryTask';

interface Props {
  date: moment.Moment;
  entry: {
    id: string;
    name: string;
    collaborators: Array<Party>;
    entryTasks: Array<CalendarEntryTask>;
    previewText?: string;
  };
  isLoadingData: boolean;
}

class EntryExcerpt extends React.Component<Props> {
  static defaultProps = {entryTasks: []};

  _handleEntryClick = (): void => {
    FileBrowserActions.openFile(this.props.entry.id);
  };

  render(): JSX.Element {
    return (
      <div className="u-spacing-bottom">
        <div className="entryExcerpt-header u-lr-split">
          <div className="u-pointer" onClick={this._handleEntryClick}>
            <BenchlingIcon icon={FolderItemIcon.Entry} className="u-mini-spacing-right" />
            {this.props.entry.name}
          </div>
          <PartyAvatarList
            size={AvatarSize.XXSMALL}
            maxAvatars={3}
            parties={this.props.entry.collaborators}
            tooltipPlacement={FloatingPlacement.TOP}
          />
        </div>
        {this.props.entry.entryTasks.length === 0 ? (
          // TODO(T7749): Show the preview text when the whitespace is fixed.
          <div>
            <div className="entryExcerpt-previewText">{this.props.entry.previewText}</div>
            <div className="entryExcerpt-entryTask u-faded u-italic">
              Track your to-do's by adding checkboxes to your entry.
            </div>
          </div>
        ) : (
          <div>
            {this.props.entry.entryTasks.map((entryTask, i) => (
              <EntryTask
                key={`entryTask-${i}`}
                date={this.props.date}
                entryId={this.props.entry.id}
                entryTask={entryTask}
                isLoadingData={this.props.isLoadingData}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default EntryExcerpt;
